<div class="flex flex-col w-full">
    <div class="bg-background w-full">
    <div class="container md:ml-16 !text-left pt-6 pb-12 px-2 md:px-0">
        <h1 class="pb-2 !text-left">{{ isNewUser ? 'Herzlich willkommen bei der KnOot Academy!' : 'Willkommen zurück!' }}</h1>
        <p class="!text-left">
            @if (isNewUser) {
                Wir freuen uns, dass wir dich auf eine spannende Reise mitnehmen können.
                Hier kannst du die Inhalte deiner Kurse wiederholen, dich im Endlosmodus bei verschiedenen Fragen und
                Themengebieten selbst challengen,
                dein Wissen durch Quizzen steigern oder dich mit der Prüfungssimulation vorbereiten.
            } @else {
                Schön, dass du wieder da bist! Mach da weiter, wo du aufgehört hast.
            }
        </p>
        </div>
    </div>


@if (!isNewUser) {
    @if(achievements.length > 0){
<div class="odd:bg-background even:bg-background-dark w-full md:py-6 md:px-16 py-4 px-2">
    <h1>Deine bisherigen Erfolge</h1>
    <div class="flex flex-row flex-nowrap overflow-x-auto scrollbar overflow-y-hidden py-4 pr-12 gap-12">
        <!-- <div class="absolute right-0 w-20 h-44 from-white-dark bg-gradient-to-l z-50"></div> -->
        @for(achievement of achievements; track achievement.id){
        <div
            class="dark-shadow font-shadow rounded shrink-0 w-44 h-44 flex flex-col justify-end text-center relative">

            <i class="fa-solid fa-award z-50 text-3xl text-blue dark:text-white mb-2 block mx-auto"></i>

            <h3 class="z-50 text-lg pb-6 dark:text-white">
                @if(achievement.type === 'test-completions' && achievement.count === 1){
                Prüfung {{ achievement.expand.exam?.name }} bestanden!
                } @else if (achievement.type === 'test-completions') {
                Prüfung {{ achievement.expand.exam?.name }} {{ achievement.count }}x bestanden!
                } @else if (achievement.type === 'correct-streak') {
                {{ achievement.count }} Fragen in der Reihe richtig!
                }
            </h3>
            <div class="absolute w-44 h-44 flex text-center opacity-50 items-center rounded bg-primary opacity-[15%]"></div>
        </div>
        }
    </div>
</div>
}
    <div
        class="odd:bg-background even:bg-background-dark w-full md:py-4 md:px-16 py-4 pl-2 overflow-x-auto overflow-y-hidden scrollbar">
        <h2 class="pb-2">Deine letzten Trainings</h2>
        <div class="flex flex-nowrap gap-12 h-64 py-4">
            <!-- <div class="absolute right-0 w-20 h-56 from-white-dark bg-gradient-to-l z-50"></div> -->
            @for (training of lastTrainings; track training.id) {
            @if(training.mode == 'exam'){
            <a [routerLink]="['/test/create', training.expand.course.id]">
    <div
        class="group b-4 w-44 h-56 flex flex-col justify-between font-shadow hover:w-48 hover:h-60 shrink-0 transition-all relative dark-shadow rounded">
        <div
            class="z-40 text-center text-blue dark:text-white font-bold group-hover:scale-125 transition-all duration-500 ease-out">
            <h3 class="text-2xl dark:text-white mt-8">{{ training.expand.course.name }}</h3>
            <h3 class="text-base dark:text-white">Prüfungssimulation</h3>
        </div>
        <div class="absolute w-44 h-56 group-hover:w-48 transition-all group-hover:h-60 shrink-0 shadow rounded border-4 border-white">
            <div class="absolute inset-0 bg-primary-hover opacity-[15%] rounded"></div>

            <div class="relative w-full h-full flex flex-col justify-end items-center">
                <img src="./assets/img/card-images/knoot_pruefungssim.svg" class="w-14 mb-2" alt="Course Image">
            </div>
        </div>
    </div>
</a>
            } @else if(training.mode == 'endless'){
            <a [routerLink]="['/endless/start', training.expand.course.id]">
    <div
        class="group b-4 w-44 h-56 flex flex-col justify-between font-shadow hover:w-48 hover:h-60 shrink-0 transition-all relative dark-shadow rounded">
        <div
            class="z-40 text-center text-blue dark:text-white font-bold group-hover:scale-125 transition-all duration-500 ease-out">
            <h1 class="text-2xl dark:text-white mt-8">{{ training.expand.course.name }}</h1>
            <h3 class="text-base dark:text-white">Endlosmodus</h3>
        </div>
        <div
            class="absolute w-44 h-56 group-hover:w-48 transition-all group-hover:h-60 shrink-0 shadow rounded border-4 border-white"
            >
            <div class="absolute inset-0 bg-primary-hover opacity-[15%] rounded"></div>

            <div class="relative w-full h-full flex flex-col justify-end items-center">
                <img src="./assets/img/card-images/knoot_endlosmodus.svg" class="w-14 mb-2" alt="Course Image">
            </div>
        </div>
    </div>
</a>
            } @else if(training.mode == 'repeat'){
            <a [routerLink]="['/repeat/start']">
                <div
                    class="group b-4 w-44 h-56 flex flex-col justify-center font-shadow hover:w-48 hover:h-60 shrink-0 transition-all relative dark-shadow rounded">
                    <ng-icon class="z-40 absolute text-lg right-2 top-2 text-blue dark:text-white"
                        name="faSolidClipboardQuestion"></ng-icon>
                    <div
                        class="z-40 text-center text-blue font-bold group-hover:scale-125 transition-all duration-500 ease-out">
                        <h3 class="dark:text-white">Falsche Fragen Wiederholen</h3>
                    </div>
                    <div
                        class="absolute w-44 h-56 group-hover:w-48 transition-all group-hover:h-60 opacity-50 flex flex-col justify-center shrink-0 shadow rounded bg-primary opacity-[15%] border-4 border-white">
                    </div>
                </div>
            </a>
            }
            }
            <a routerLink="/training/all">
                <div
                    class="group b-4 w-44 h-56 flex flex-col justify-center hover:w-48 hover:h-60 shrink-0 transition-all relative dark-shadow rounded">
                    <div
                        class="z-40 text-center text-blue dark:text-white font-bold font-shadow group-hover:scale-125 transition-all duration-500 ease-out">
                        <ng-icon class="z-40 text-4xl text-blue dark:text-white" name="faSolidArrowRight"></ng-icon>
                        <h3 class="text-base dark:text-white">Trainingsbereich</h3>
                    </div>
                    <div
                        class="absolute w-44 h-56 group-hover:w-48 transition-all group-hover:h-60 opacity-50 flex flex-col justify-center shrink-0 shadow rounded bg-primary opacity-[15%] border-4 border-white">
                    </div>
                </div>
            </a>
        </div>
        <!-- <span>Mit 🚧 markierte Kurse sind noch im Aufbau</span> -->
    </div>

    @if(lastResults.length > 0){
    <div class="odd:bg-background even:bg-background-dark group w-full md:py-6 md:px-16 py-4 px-2">
        <h2>Deine letzten Ergebnisse</h2>
        @for(entry of lastResults; track entry.date){
        <h3 class="pt-8 pb-2">{{ entry.date | date:'dd.MM.yyyy'}}</h3>
        <div class="flex flex-col gap-4">
            @for (result of entry.results; track result.id) {
            <!-- mobile -->
            <div
                class="md:hidden group-odd:bg-background-dark group-even:bg-background rounded p-4 flex lg:justify-between lg:flex-row flex-col flex-wrap dark:border dark:border-grey">
                <h3 class="lg:w-32 shrink-0">{{ result.title }} Prüfungssimulation</h3>
                <span>Durchgeführt um {{ result.startTime | date:'HH:mm' }} Uhr</span>
                <span>Benötigte Zeit: {{ result.timeTaken | date:'mm:ss'}} Minuten</span>
                <span class="lg:w-32 shrink-0">{{ result.score | number:'1.2-2' }}% bei {{ result.questionAmount }}
                    Fragen erreicht</span>
                <a class="pt-2" [routerLink]="['/evaluation', result.id]"><span>Ansehen</span></a>
            </div>

            <!-- desktop-->
            <div
                class="hidden md:flex group-odd:bg-background-dark group-even:bg-background rounded p-4 lg:justify-between lg:flex-row flex-col flex-wrap dark:border dark:border-grey">
                <span>{{ result.startTime | date:'HH:mm' }} Uhr</span>
                <span class="lg:w-32 shrink-0">{{ result.title }}</span>
                <span>{{ result.questionAmount }} Fragen</span>
                <span>Benötigte Zeit: {{ result.timeTaken | date:'mm:ss'}} Minuten</span>
                <span class="lg:w-32 shrink-0">{{ result.score | number:'1.2-2' }}% erreicht</span>
                <a [routerLink]="['/evaluation', result.id]"><span>Ansehen</span></a>
            </div>
            }
        </div>
        }
    </div>
    }
    <div class="even:hidden bg-background h-8">
    </div>
}

    @if (isNewUser) {
<div class="odd:bg-background even:bg-background-dark w-full md:py-4 md:px-16 py-4 pl-2 overflow-x-auto overflow-y-hidden scrollbar">
    <h2 class="pb-2">Womit möchtest du starten?</h2>
    <div class="flex flex-nowrap gap-12 h-64 py-4">
        @for (course of availableCourses; track course.id) {
        <a [routerLink]="['/training', course.id]">
            <div
                class="group b-4 w-44 h-56 flex flex-col justify-between font-shadow hover:w-48 hover:h-60 shrink-0 transition-all relative dark-shadow rounded">
                <div
                    class="z-40 text-center text-blue dark:text-white font-bold group-hover:scale-125 transition-all duration-500 ease-out">
                    <h3 class="text-xl dark:text-white mt-8">{{ course.name }}</h3>
                    <h3 class="text-base dark:text-white">ausprobieren</h3>
                </div>
                <div
                    class="absolute w-44 h-56 group-hover:w-48 transition-all group-hover:h-60 shrink-0 shadow rounded border-4 border-white">
                    <div class="absolute inset-0 bg-primary-hover opacity-[15%] rounded"></div>

                    <div class="relative w-full h-full flex flex-col justify-end items-center">
                        <img src="./assets/img/card-images/knoot_noicon.svg" class="w-14 mb-2" alt="Course Image">
                    </div>
                </div>
            </div>
        </a>
        }
        <a [routerLink]="['/kurse', psm1CourseId]">
    <div
        class="group b-4 w-44 h-56 flex flex-col justify-between font-shadow hover:w-48 hover:h-60 shrink-0 transition-all relative dark-shadow rounded">
        <div
            class="z-40 text-center text-blue dark:text-white font-bold group-hover:scale-125 transition-all duration-500 ease-out">
            <h3 class="text-xl dark:text-white mt-8">PSM I</h3>
            <h3 class="text-base dark:text-white">Vorbereitung <br> ansehen</h3>
        </div>
        <div
            class="absolute w-44 h-56 group-hover:w-48 transition-all group-hover:h-60 shrink-0 shadow rounded border-4 border-white">
            <div class="absolute inset-0 bg-primary-hover opacity-[15%] rounded"></div>

            <div class="relative w-full h-full flex flex-col justify-end items-center">
                <img src="./assets/img/card-images/knoot_kaufbar.svg" class="w-14 mb-2" alt="Course Image">
            </div>
        </div>
    </div>
</a>

    <a routerLink="/training/all">
    <div
        class="group b-4 w-44 h-56 flex flex-col justify-between font-shadow hover:w-48 hover:h-60 shrink-0 transition-all relative dark-shadow rounded">
        <div
            class="z-40 text-center text-blue dark:text-white font-bold group-hover:scale-125 transition-all duration-500 ease-out">
            <h3 class="text-xl dark:text-white mt-8">Weitere Fragendecks ansehen</h3>
        </div>
        <div
            class="absolute w-44 h-56 group-hover:w-48 transition-all group-hover:h-60 shrink-0 shadow rounded border-4 border-white">
            <div class="absolute inset-0 bg-primary-hover opacity-[15%] rounded"></div>

            <div class="relative w-full h-full flex flex-col justify-end items-center">
                <img src="./assets/img/card-images/knoot_noicon.svg" class="w-14 mb-2" alt="Course Image">
            </div>
        </div>
    </div>
</a>

<a routerLink="/glossary">
    <div
        class="group b-4 w-44 h-56 flex flex-col justify-between font-shadow hover:w-48 hover:h-60 shrink-0 transition-all relative dark-shadow rounded">
        <div
            class="z-40 text-center text-blue dark:text-white font-bold group-hover:scale-125 transition-all duration-500 ease-out">
            <h3 class="text-xl dark:text-white mt-8">Glossar <br> ansehen</h3>
        </div>
        <div
            class="absolute w-44 h-56 group-hover:w-48 transition-all group-hover:h-60 shrink-0 shadow rounded border-4 border-white">
            <div class="absolute inset-0 bg-primary-hover opacity-[15%] rounded"></div>

            <div class="relative w-full h-full flex flex-col justify-end items-center">
                <img src="./assets/img/card-images/knoot_noicon.svg" class="w-14 mb-2" alt="Course Image">
            </div>
        </div>
    </div>
</a>

<a [routerLink]="['/kurse', palCourseId]">
    <div
        class="group b-4 w-44 h-56 flex flex-col justify-between font-shadow hover:w-48 hover:h-60 shrink-0 transition-all relative dark-shadow rounded">
        <div
            class="z-40 text-center text-blue dark:text-white font-bold group-hover:scale-125 transition-all duration-500 ease-out">
            <h3 class="text-xl dark:text-white mt-8">PAL</h3>
            <h3 class="text-base dark:text-white">Vorbereitung <br> ansehen</h3>
        </div>
        <div
            class="absolute w-44 h-56 group-hover:w-48 transition-all group-hover:h-60 shrink-0 shadow rounded border-4 border-white">
            <div class="absolute inset-0 bg-primary-hover opacity-[15%] rounded"></div>

            <div class="relative w-full h-full flex flex-col justify-end items-center">
                <img src="./assets/img/card-images/knoot_kaufbar.svg" class="w-14 mb-2" alt="Course Image">
            </div>
        </div>
    </div>
</a>

    </div>
</div>
}

</div>